import { sortingHelper, Filters } from '@ui/src';
import { CountryItem } from '../types';

const filtersHelperCountries = (
  items: CountryItem[],
  sortKey: string,
  direction: 'asc' | 'desc',
  filters: Filters,
): CountryItem[] => {
  let nextItems: CountryItem[] = items;

  Object.keys(filters).map((fieldName) => {
    if (filters[fieldName] && fieldName !== 'cursor') {
      nextItems = nextItems.filter((item) => {
        let value;

        if (fieldName === 'active') {
          value = item[fieldName];
        } else {
          value = (item[fieldName as keyof CountryItem] as string)
            ?.toLowerCase()
            ?.includes(filters[fieldName].value[0].toLowerCase());
        }

        return value;
      });
    }

    return nextItems;
  });

  if (sortKey && direction) {
    nextItems = sortingHelper<CountryItem>(nextItems, sortKey, direction);
  }

  return nextItems;
};

export default filtersHelperCountries;
